import { React, useState, useEffect } from 'react';
import '../style/HomePage.scss';

import { Link } from "react-router-dom";

import Login from "../components/Login";
import Feedback from "../components/Feedback";

import dailyPuzzle from "../images/svg/daily-puzzle.svg";
import basic from "../images/svg/basic.svg";
import advance from "../images/svg/advance.svg";
import master from "../images/svg/master.svg";

const HomePage = () => {
	
	const [getBasicFilteredPuzzlePlayedList, setGetBasicFilteredPuzzlePlayedList] = useState(null);
	const [getAdvanceFilteredPuzzlePlayedList, setGetAdvanceFilteredPuzzlePlayedList] = useState(null);
	const [getMasterFilteredPuzzlePlayedList, setGetMasterFilteredPuzzlePlayedList] = useState(null);
	
	/* const [testNumber, setTestNumber] = useState(0);
	const [getTestNumber, setGetTestNumber] = useState(0); */
	
	useEffect(() => {	
		
		setGetBasicFilteredPuzzlePlayedList(localStorage.getItem("storeBasicFilteredPuzzlePlayedList"));
		setGetAdvanceFilteredPuzzlePlayedList(localStorage.getItem("storeAdvanceFilteredPuzzlePlayedList"));
		setGetMasterFilteredPuzzlePlayedList(localStorage.getItem("storeMasterFilteredPuzzlePlayedList"));
	
	}, []);
	
	
	const basicHandleClick = () => {
		localStorage.setItem('puzzleDifficulty', '0');
	}
	
	const advanceHandleClick = () => {
		localStorage.setItem('puzzleDifficulty', '1');
	}
	
	const masterHandleClick = () => {
		localStorage.setItem('puzzleDifficulty', '2');
	}
	
	
	/* const getClick = () => {
		setGetTestNumber(localStorage.getItem("setTestNumber"));
		console.log('getTestNumber - ', getTestNumber);
		setTestNumber(getTestNumber);
		console.log(' new testNumber - ', testNumber);
	}
	
	const testClick = () => {
		setTestNumber(testNumber+1);
		console.log('testNumber - ', testNumber);
		localStorage.setItem('setTestNumber', testNumber);
	}

	useEffect(() => {
		getClick();
	}, [getTestNumber]); */
	
	
	/* const handleClick1 = () => {
		localStorage.clear();
	} */
  
	return (
		<div className="container home-page">
			
			<div className="content-box">
				
				<Login />
				
				<Feedback />
				
				{/* <p onClick={testClick}>click me</p>
				<p>getTestNumber - {getTestNumber}</p>
				<p>testNumber - {testNumber}</p> */}
				
				{/* <div className="daily-puzzle-box">
					<div className="daily-puzzle-sub">
						<img src={dailyPuzzle} className="daily-puzzle-svg" alt="icon" />
						<div className="daily-puzzle-text-box">
							<p className="daily-puzzle-text">Daily Puzzle</p>
							<p className="daily-puzzle-date">28th June</p>
						</div>	
					</div>
					<Link className="daily-puzzle-anchor" to="/puzzle">Play now</Link>
				</div> */}
				
				<div className="home-page-overlay">
					<div className="puzzle-difficulty-box posr">
						<div className="puzzle-difficulty-img-box wdh"><img src={basic} className="puzzle-difficulty-img" alt="icon" /></div>
						<div className="puzzle-difficulty-info-box wdh">
							<div className="puzzle-difficulty-title-box">
								{/* <p className="puzzle-difficulty-title">Basic puzzles</p> */}
								<p className="puzzle-difficulty-title">Rookie riddles </p>
								<p className="puzzle-difficulty-game-count">{getBasicFilteredPuzzlePlayedList == null ? '0' : getBasicFilteredPuzzlePlayedList}/350</p>
							</div>
							<p className="puzzle-difficulty-text">Set the stage for your chess conquest with these simple puzzles!</p>
							{/* <p className="puzzle-difficulty-text">The very first level and basic puzzles to set your basics right!</p> */}
						</div>
						<div className="puzzle-difficulty-info-box wdh">
							<Link onClick={basicHandleClick} className="basic-puzzle-anchor puzzle-difficulty-anchor" to="/puzzle">Play now</Link>
						</div>
					</div>
					<div className="puzzle-difficulty-box posr">
						<div className="puzzle-difficulty-img-box wdh"><img src={advance} className="puzzle-difficulty-img" alt="icon" /></div>
						<div className="puzzle-difficulty-info-box wdh">
							<div className="puzzle-difficulty-title-box">
								{/* <p className="puzzle-difficulty-title">Advance puzzles</p> */}
								<p className="puzzle-difficulty-title">Knight's attack </p>
								<p className="puzzle-difficulty-game-count">{getAdvanceFilteredPuzzlePlayedList == null ? '0' : getAdvanceFilteredPuzzlePlayedList}/350</p>
							</div>
							<p className="puzzle-difficulty-text">Keep calm and castle on with these intermediate chess challenges.</p>
							{/* <p className="puzzle-difficulty-text">With some experience, now you can level up your game with these puzzles</p> */}
						</div>
						<div className="puzzle-difficulty-info-box wdh">
							<Link onClick={advanceHandleClick} className="advance-puzzle-anchor puzzle-difficulty-anchor" to="/puzzle">Play now</Link>
						</div>
					</div>
					<div className="puzzle-difficulty-box posr">
						<div className="puzzle-difficulty-img-box wdh"><img src={master} className="puzzle-difficulty-img" alt="icon" /></div>
						<div className="puzzle-difficulty-info-box wdh">
							<div className="puzzle-difficulty-title-box">
								{/* <p className="puzzle-difficulty-title">Master puzzles</p> */}
								<p className="puzzle-difficulty-title">Elite enigmas</p>
								<p className="puzzle-difficulty-game-count">{getMasterFilteredPuzzlePlayedList == null ? '0' : getMasterFilteredPuzzlePlayedList}/300</p>
							</div>
							{/* <p className="puzzle-difficulty-text">You’ve aced this game! Now face some serious challenges with these puzzles</p> */}
							<p className="puzzle-difficulty-text">Ascend to the ranks of chess elite with these complex conundrums.</p>
						</div>
						<div className="puzzle-difficulty-info-box wdh">
							<Link onClick={masterHandleClick} className="master-puzzle-anchor puzzle-difficulty-anchor" to="/puzzle">Play now</Link>
						</div>
					</div>
				</div>
				
			</div>
			
			<div className="footer">
				{/* <p>© 2015-2023 Square Off Inc. All rights reserved.</p> */}
				<p>A <a className="" target="_blank" rel="noreferrer" href="https://squareoffnow.com/">Square Off</a> Product &#169; 2023 | All rights reserved</p>
			</div>
			
		</div>
	);
  
}

export default HomePage;